import React,{Component} from 'react';
import Notification from './Notification';
class ForemanConfigView extends Component{

  constructor(props){
    super(props);
    let initialConfig =  {workTime:7.5,employeeNotice:2,foremanNotice:3};
    let timeConfig
    if(this.props.timeConfigs != null){
      timeConfig = this.props.timeConfigs;
    }else{
      timeConfig = initialConfig;
    }
    this.state = {timeConfigs:timeConfig };
    this.updateInputValue = this.updateInputValue.bind(this);
    this.changeConfig = this.changeConfig.bind(this);
  }
  updateInputValue(evt) {
    let inputName =  evt.target.name;

    let timeConfigs = this.state.timeConfigs;
    timeConfigs[inputName]= parseFloat(evt.target.value);
    this.setState({timeConfigs:timeConfigs});

   }

   changeConfig(){
     this.props.setTimeConfig(this.state.timeConfigs);
   }
  render(){
    return(

      <div className="configView">
<div className="workersListHeader alert alert-info">Aikarajat</div>
        <form>
          <label htmlFor="workTime" ><span>Päivän pituus(h)</span><input type="number" step="0.1" name="workTime"  value={this.state.timeConfigs.workTime} onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="employeeNotice" ><span>Varoitusaika työntekijälle(h)</span><input type="number" step="0.1"  value={this.state.timeConfigs.employeeNotice} name="employeeNotice" onChange={evt => this.updateInputValue(evt)} /></label>
          <label htmlFor="foremanNotice" ><span>Varoitusaika työnjohtajalle(h)</span><input type="number" step="0.1"  value={this.state.timeConfigs.foremanNotice} name="foremanNotice" onChange={evt => this.updateInputValue(evt)} /></label>
          <button type="button" className="btnThirdButton" onClick={this.changeConfig}>Tallenna</button>
          <button type="button" className="btnClose" onClick={this.props.changeToEmployeesView}>Peruuta</button>
        </form>
    </div>
)
}
}
export default ForemanConfigView;
